export default __webpack_public_path__ + "static/flex2x-bcbd12195c190d31b9d0adaf34e7d542.png";